<!-- Component that implements a list of documents -->
<template lang="html">
  <div>

    <c-confirm-dialog v-model="dialogConfirmaExclusao" @yes="excluirAtividade()" titulo="Deseja realmente excluir a atividade?">
      A atividade "{{this.descricaoAtividadeExclusao}}" será excluída após clicar na opção "Sim".
    </c-confirm-dialog>

    <v-data-table
    :headers="headers"
    :items="listaAtividades"
    :search="search"
    :no-data-text="'Este projeto não possui atividades.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.opcoes="props">
        <v-btn v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true" color="primary" text icon @click="botaoEditarAtividade(idProjeto, props.item.id)">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1 && projeto.situacao.item === 15) || (projeto.assessor === true && projeto.situacao.item === 15)" color="primary" text icon @click="botaoExcluirAtividade(props.item.id, props.item.descricao)" >
          <v-icon>delete</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.nomeDescricao="props">
        <div v-if="props.item.detalhamento !== null && props.item.detalhamento !== ''">{{props.item.descricao}}<br><br>{{props.item.detalhamento}}</div>
        <div v-else>{{props.item.descricao}}</div>
      </template>
      <template v-slot:item.dtInicioPrevisto="props">{{dates.format(props.item.dtInicioPrevisto)}}</template>
      <template v-slot:item.dtFimPrevisto="props">{{dates.format(props.item.dtFimPrevisto)}}</template>
      <template v-slot:item.dtInicioEfetivo="props">{{dates.format(props.item.dtInicioEfetivo)}}</template>
      <template v-slot:item.dtFimEfetivo="props">{{dates.format(props.item.dtFimEfetivo)}}</template>
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaAtividades.length }} atividades
      </template>
    </v-data-table>
    <br><br>

    <c-card-footer
      :projeto="this.projeto"
      :extensao="this.extensao"
      proxima="VinculosProjeto"
      editar="NovaAtividade"
      nome_editar="Nova Atividade"
      :habilitaBotaoGerarPDFAcao=true
      :habilitaBotaoFinalizarAcao=true
    >
    </c-card-footer>
  </div>
</template>

<script>
import ConfirmDialog from '@/components/c-confirm-dialog'
import CardFooter from '@/components/c-card-footer'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto', 'extensao'],
  data: () => ({
    dialogConfirmaExclusao: false,
    idAtividadeExclusao: 0,
    descriaoAtividadeExclusao: '',
    listaAtividades: [],
    dates: dates,
    search: null,
    sortBy: 'funcao.descricao',
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Nome e descrição sucinta da atividade', align: 'left', width: '58%', value: 'nomeDescricao' },
      { text: 'Início previsto', align: 'left', width: '9%', value: 'dtInicioPrevisto' },
      { text: 'Conclusão prevista', align: 'left', width: '9%', value: 'dtFimPrevisto' },
      { text: 'Início efetivo', align: 'left', width: '9%', value: 'dtInicioEfetivo' },
      { text: 'Conclusão efetiva', align: 'left', width: '9%', value: 'dtFimEfetivo' },
      { text: 'Opções', align: 'left', width: '6%', value: 'opcoes' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    carregaAtividades: function (idProjeto) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando atividades.' })
      projetos.getAtividadesDoProjeto(idProjeto)
      .then(response => {
        this.listaAtividades = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando atividades.' })
      })
    },
    botaoExcluirAtividade: function (idAtividade, descricao) {
      this.idAtividadeExclusao = idAtividade
      this.descricaoAtividadeExclusao = descricao
      this.dialogConfirmaExclusao = true
    },
    excluirAtividade: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo atividade.' })
      projetos.deleteAtividade(this.idProjeto, this.idAtividadeExclusao)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.carregaAtividades(this.idProjeto)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo atividade.' })
      })
    },
    botaoEditarAtividade: function (idProjeto, idAtividade) {
      this.$router.push({ name: 'EditarAtividade', params: {idProjeto: idProjeto, idAtividade: idAtividade} })
    }
  },
  mounted () {
    this.carregaAtividades(this.idProjeto)
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-card-footer': CardFooter,
    'c-confirm-dialog': ConfirmDialog
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// projeto-atividades-tabela.vue?db3d06c6